import * as Sentry from '@sentry/angular';

export const setSentryContext = (name: string, data: Record<string, unknown>): void => {
  Sentry.setContext(name, data);
};

export const setSentryTag = (key: string, value: string): void => {
  Sentry.setTag(key, value);
};

export const setSentryUser = (user: { id: string; email?: string; username?: string } | null): void => {
  Sentry.setUser(user);
};
